import { scrollIntoView } from '@theme/scrolling';

/**
 * Handles anchor scrolling functionality
 * Scrolls to elements with ID containing "section_jGDWpH" when URL contains "#product_content"
 */
const TARGET_SELECTOR = '[id*="section_jGDWpH"]';
const HASH_TRIGGER = '#product_content';
const OBSERVE_TIMEOUT = 10000;

function scrollToTarget(element) {
  scrollIntoView(element, {
    behavior: 'smooth',
    block: 'start',
    inline: 'start',
  });
}

function findAndScroll() {
  const target = document.querySelector(TARGET_SELECTOR);
  if (target) {
    scrollToTarget(target);
    return true;
  }
  return false;
}

function waitForTargetAndScroll() {
  if (findAndScroll()) return;

  const observer = new MutationObserver(() => {
    if (findAndScroll()) {
      observer.disconnect();
      clearTimeout(timeout);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const timeout = setTimeout(() => {
    observer.disconnect();
  }, OBSERVE_TIMEOUT);
}

function checkHash() {
  if (window.location.hash.includes(HASH_TRIGGER)) {
    waitForTargetAndScroll();
  }
}

checkHash();
window.addEventListener('hashchange', checkHash);

export default null;
